var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcquaintance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36V35C21.9 35 23.5 33.1 23.5 31.5V22.5C23.5 19.6 17.2 18 14 18C10.8 18 4.5 19.6 4.5 22.5V31.5C4.5 33.1 6.1 35 8 35V36C5.5 36 3.5 33.6 3.5 31.5V22.5C3.5 18.8 10.2 17 14 17C17.8 17 24.5 18.8 24.5 22.5V31.5C24.5 33.6 22.5 36 20 36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36V35C49.9 35 51.5 33.1 51.5 31.5V22.5C51.5 19.6 45.2 18 42 18C38.8 18 32.5 19.6 32.5 22.5V31.5C32.5 33.1 34.1 35 36 35V36C33.5 36 31.5 33.6 31.5 31.5V22.5C31.5 18.8 38.2 17 42 17C45.8 17 52.5 18.8 52.5 22.5V31.5C52.5 33.6 50.5 36 48 36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C11.4 15 9.5 13.1 9.5 10.5V8.5C9.5 5.9 11.4 4 14 4C16.6 4 18.5 5.9 18.5 8.5V10.5C18.5 13.1 16.6 15 14 15ZM14 5C11.9 5 10.5 6.4 10.5 8.5V10.5C10.5 12.6 11.9 14 14 14C16.1 14 17.5 12.6 17.5 10.5V8.5C17.5 6.4 16.1 5 14 5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15C39.4 15 37.5 13.1 37.5 10.5V8.5C37.5 5.9 39.4 4 42 4C44.6 4 46.5 5.9 46.5 8.5V10.5C46.5 13.1 44.6 15 42 15ZM42 5C39.9 5 38.5 6.4 38.5 8.5V10.5C38.5 12.6 39.9 14 42 14C44.1 14 45.5 12.6 45.5 10.5V8.5C45.5 6.4 44.1 5 42 5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24.5H19.5V50.5H20.5V24.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 24.5H47.5V50.5H48.5V24.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24.5H7.5V50.5H8.5V24.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 24.5H35.5V50.5H36.5V24.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 34.5H13.5V50.5H14.5V34.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 34.5H41.5V50.5H42.5V34.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcquaintance);
export default __webpack_public_path__ + "static/media/acquaintance.b8f5ca5a5dc3be5855a81fb8a343c57b.svg";
export { ForwardRef as ReactComponent };